import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "components/Elements/Dropdown";
import FieldLabel from "./FieldLabel";

const ReportPickerField = ({ reports = [], value, onChange, disabled = false }) => {
	const { t } = useTranslation();
	const options = useMemo(
		() => reports.map((r) => ({ label: r.name, value: r.reportType })),
		[reports]
	);
	const selected = options.find((o) => o.value === value) || {};

	return (
		<div>
			<FieldLabel required>{t("label.whichReport")}</FieldLabel>
			<Dropdown
				options={options}
				selectedValue={selected}
				onChange={(opt) => onChange(opt.value)}
				placeholder={t("placeholder.selectReport")}
				width="100%"
				disabled={disabled}
			/>
		</div>
	);
};

export default ReportPickerField;
